import React from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Grid, Flex } from 'lese'

export const TableHead = styled.div`
  display: contents;
  > * {
    padding: 8px;
    align-self: center;

    ${({ border }) => border && `border-bottom: 1px solid ${colors.borderColor};`}
  }
`

export const TableRow = styled.div`
  display: contents;

  &:nth-of-type(2n + 1) > * {
    ${({ noBackground }) => !noBackground && `background: ${colors.background800};`}
  }

  &:nth-of-type(2n) > * {
    ${({ noBackground }) => !noBackground && `background: ${colors.background700};`}
  }
`

const TableCell = styled(Flex)`
  padding: 16px 8px;
  align-self: stretch;
  break-before: always;

  @media print {
    padding: 8px 4px;
  }
`
TableCell.defaultProps = { yAlign: true }

export { TableCell }

export const ClickableTableCell = styled(TableCell)`
  cursor: pointer;
`

export const TableHeader = styled(Flex)`
  padding: 16px 8px;
  align-self: stretch;
  background-color: ${colors.backgroundInverted};
  color: ${colors.textInverted};
`

export const TableGrid = styled(Grid)`
  width: ${({ width }) => (width ? `${width}%` : '100%')};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}%` : '100%')};
  overflow-x: auto;
`

export default ({
  columns,
  data,
  setCustomLinks,
  updateLinks,
  Row = TableRow,
  Cell = TableCell,
  Header = TableHeader,
  Head = TableHead
}) => {
  return (
    <>
      <TableGrid
        columns={`${columns.map(val => val.size?.split('x')[0] || '1').join('fr ')}fr`}
        width="100"
      >
        <Head>
          {columns.map(column => (
            <Header {...column}>{column.header}</Header>
          ))}
        </Head>

        {data?.length > 0 &&
          data.map(dataRow => (
            <Row
              data={dataRow}
              setCustomLinks={setCustomLinks}
              customLinks={data}
              updateLinks={updateLinks}
            >
              {columns.map(column => {
                const ColumnCell = column.Cell ?? Cell
                return (
                  <ColumnCell data={dataRow} column={column}>
                    {dataRow[column.accessor]}
                  </ColumnCell>
                )
              })}
            </Row>
          ))}
      </TableGrid>
    </>
  )
}
